/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Select_Profile_TextInputs */



/**
* | output |
* | --- |
* | "Please select a profile to download the subtitle file in." |
*
* @param {Select_Profile_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const select_profile_text = /** @type {((inputs?: Select_Profile_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Select_Profile_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez sélectionner un profil pour télécharger le fichier de sous-titres.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie ein Profil aus, in dem die Untertiteldatei heruntergeladen werden soll.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un profilo in cui scaricare il file dei sottotitoli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, выберите профиль, чтобы загрузить файл субтитров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un perfil para descargar el archivo de subtítulos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请选择要下载字幕文件的配置文件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕ファイルをダウンロードするプロファイルを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया सबटाइटल फ़ाइल डाउनलोड करने के लिए एक प्रोफ़ाइल चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um perfil para baixar o arquivo de legenda.")
	return /** @type {LocalizedString} */ ("Please select a profile to download the subtitle file in.")
});